module.exports = __webpack_public_path__ + "static/media/energy-smart-tile-update.227997ed.jpg";